import { useState, useCallback } from "react";

import debounce from "lodash/debounce";

const TIMEOUT_CONFIG = 500;

const useSearchMultiAutoComplete = <T>(
  defaultValue?: { label: string; value: T }[] | null | undefined
) => {
  const [keyword, setKeyword] = useState("");
  const [isFocus, setIsFocus] = useState(false);
  const [value, setValue] = useState<
    { label: string; value: T | null | undefined }[] | null | undefined
  >(defaultValue || undefined);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSetKeyword = useCallback(
    debounce((txt: string, reason: string) => {
      if (reason === "input" || reason === "clear") {
        setKeyword(txt);
      }
    }, TIMEOUT_CONFIG),
    []
  );

  const onChange = (
    newValue: { label: string; value: T | null | undefined }[] | null
  ) => {
    setValue(newValue);
  };

  const onFocus = () => setIsFocus(true);
  const onBlur = () => setIsFocus(false);

  return {
    keyword,
    value,
    isFocus,
    setIsFocus,
    onChange,
    setKeyword: debounceSetKeyword,
    onFocus,
    onBlur,
  };
};

export default useSearchMultiAutoComplete;
